import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { NavUtils } from "../../../navigation";
import KeycloakService from "../../../services/KeycloakService";
import { translate } from "../../providers";
import permissions from "../../providers/permissions/permissions";
import { icon, IconComponent } from "../icon-component";
import { CustomButtonLink } from "../links";
import TitleMenu from "./TitleMenu";
import styles from "./ViewBanner.module.css";

export default function ViewBanner({ forceLength = false, className = null, options = [], titles }) {
	// Limit options display to 3. If need more, use a menu
	options.length = (forceLength && options.length) || 3;
	const customFormProjectName = useSelector(({ context }) => context.customFormProjectDetails?.projectName);
	const projectName = useSelector(({ context }) => context.project?.name);
	const location = useLocation();
	const isSearch = useMemo(() => location?.pathname === "/portfolio/search-multiple", [location]);
	return (
		<>
			<header data-home className={`${className} ${styles.banner}`}>
				<CustomButtonLink
					buttonClassName={styles.banner__homeBtn}
					color="secondary"
					size="lg"
					to={
						(KeycloakService.hasRole([permissions.REALM.ADMIN.claim]) && NavUtils.goToDSI()) ||
						NavUtils.goToHome()
					}
				>
					{translate("common:btn.home")}
				</CustomButtonLink>
				{isSearch && (
					<CustomButtonLink
						buttonClassName={styles.banner__homeBtn}
						color="secondary"
						size="lg"
						to={NavUtils.goToSearchPortfolio()}
					>
						{translate("navigation:common.search-portfolio")}
					</CustomButtonLink>
				)}
				{Array.isArray(titles) && titles.length > 0 && (
					<IconComponent color="var(--grey-500)" icon={icon.faCaretRight} />
				)}
				{projectName && (
					<>
						<span className={styles.banner__title} translate="no">
							{customFormProjectName || projectName}
						</span>
						<IconComponent color="var(--grey-500)" icon={icon.faCaretRight} />
					</>
				)}
				{Array.isArray(titles) &&
					titles.length > 0 &&
					titles.map((title, index) =>
						title.title ? (
							<TitleMenu
								key={title.title + title.key}
								index={index}
								length={titles.length}
								title={title}
							/>
						) : null
					)}
				<span className={styles.banner__spacer} />
				<span className={styles.banner__options}>
					{Array.isArray(options) &&
						options.map((opt, index) => {
							const key = index;
							return (
								<span key={key} className={styles.banner__option}>
									{opt}
								</span>
							);
						})}
				</span>
			</header>
		</>
	);
}
